export default __webpack_public_path__ + "static/media/i-made-a-thing.5724aebe.gif";